"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _DashboardModal = _interopRequireDefault(require("@uppy/react/lib/DashboardModal"));

require("@uppy/core/dist/style.css");

require("@uppy/dashboard/dist/style.css");

require("@uppy/image-editor/dist/style.css");

require("@uppy/url/dist/style.min.css");

var _core = require("@material-ui/core");

var _useUppy2 = require("./utils/useUppy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      textAlign: "center"
    },
    image: {
      maxWidth: "150px",
      maxHeight: "150px",
      padding: "8px"
    },
    imageContainer: {
      width: "150px",
      height: "150px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid lightgray",
      borderRadius: "8px",
      margin: "auto",
      overflow: "hidden"
    }
  };
});

var UploadImage = function UploadImage(_ref) {
  var initialImage = _ref.initialImage,
      uploadButton = _ref.uploadButton,
      folderPath = _ref.folderPath,
      companionUrl = _ref.companionUrl,
      maxNumberOfFiles = _ref.maxNumberOfFiles,
      cropOptions = _ref.cropOptions,
      editorActions = _ref.editorActions,
      uppyDashboardProps = _ref.uppyDashboardProps,
      onSuccess = _ref.onSuccess,
      onComplete = _ref.onComplete,
      hideThumbnail = _ref.hideThumbnail;
  var classes = useStyle();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalOpen = _useState2[0],
      setModalOpen = _useState2[1];

  var _useUppy = (0, _useUppy2.useUppy)({
    onSuccess: onSuccess,
    folderPath: folderPath,
    companionUrl: companionUrl,
    maxNumberOfFiles: maxNumberOfFiles,
    cropOptions: cropOptions,
    editorActions: editorActions,
    onComplete: onComplete
  }),
      uppy = _useUppy.uppy;

  var handleOpen = function handleOpen() {
    setModalOpen(true);
  };

  var handleClose = function handleClose() {
    setModalOpen(false);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, uploadButton && uploadButton({
    onClick: handleOpen
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, (initialImage || !hideThumbnail) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.imageContainer
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: initialImage,
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.image,
    src: initialImage,
    alt: initialImage
  }))), /*#__PURE__*/_react["default"].createElement("br", null)), !uploadButton && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "contained",
    size: "small",
    color: "primary",
    type: "button",
    onClick: handleOpen
  }, !initialImage ? "Upload" : "Update"), uppy && /*#__PURE__*/_react["default"].createElement(_DashboardModal["default"], _extends({
    uppy: uppy,
    open: modalOpen,
    onRequestClose: handleClose,
    metaFields: [{
      id: "name",
      name: "File name"
    }],
    plugins: ["ImageEditor", "UrlUpload"],
    showRemoveButtonAfterComplete: true,
    closeModalOnClickOutside: true,
    locale: {
      strings: {
        retryUpload: "Retry upload"
      }
    }
  }, uppyDashboardProps))));
};

var _default = UploadImage;
exports["default"] = _default;
UploadImage.defaultProps = {
  initialImage: null,
  hideThumbnail: false,
  folderPath: "",
  companionUrl: "",
  maxNumberOfFiles: null,
  cropOptions: {},
  editorActions: {},
  uppyDashboardProps: {},
  onSuccess: function onSuccess(file, response) {
    console.log(response.uploadUrl);
  },
  onComplete: function onComplete(result) {
    console.log(result.successful);
    console.log(result.error);
  }
};